import { TRaidKillCountsByDifficulty } from '../sharedTypes';

const MYTHIC_RAID_SIZE = 20;

export const CURRENT_TIER_CROSSSERVER_RAID_KILLCOUNT: TRaidKillCountsByDifficulty = {
  normal: 7,
  heroic: 7,
  mythic: Math.floor(MYTHIC_RAID_SIZE / 2)
};

export const CURRENT_TIER_RAID_KILLCOUNT: TRaidKillCountsByDifficulty = {
  normal: 7,
  heroic: 7,
  mythic: Math.floor(MYTHIC_RAID_SIZE / 2) + 1 // so 20-man mythic guild can't split and join two diff guilds to get higher progress
};

export const PREVIOUS_TIER_RAID_KILLCOUNT: TRaidKillCountsByDifficulty = {
  normal: 6,
  heroic: 6,
  mythic: 9
};

export const PREVIOUS_XPAC_RAID_KILLCOUNT: TRaidKillCountsByDifficulty = {
  normal: 5,
  heroic: 5,
  mythic: 5
};
